import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-course-by-teacher-detail',
  templateUrl: './course-by-teacher-detail.component.html',
  styleUrls: ['./course-by-teacher-detail.component.css']
})
export class CourseByTeacherDetailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
